/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Replace_DeckInputs */



/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Players_Replace_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_replace_deck = /** @type {((inputs?: Players_Replace_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Replace_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Substituir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci")
	return /** @type {LocalizedString} */ ("Replace")
});